import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const ExpeditionStoragePage = lazy(
  () => import('@/pages/expedition-storage/ui/index'),
)

export const Route = createFileRoute('/_protected/expedition/storage')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <ExpeditionStoragePage />
    </Suspense>
  ),
})
